// types
import { i18nDispatcherWeatherWidget } from 'models/i18n';

// ==============================|| I18N EN WEATHER WIDGET ||============================== //

const enDispatcherWeatherWidget: i18nDispatcherWeatherWidget = {
  titleCurrentWeather: 'Current weather',
  titlePredictionWeather: 'Weather prediction',
  airTemperature: 'Predicted temperature',
  measuredAirTemperature: 'Measured temperature',
  extendedWeatherForecast: 'Extended weather forecast',
  weather: 'Weather',
  period: 'period',
  maxMinTooltip: 'Highest and lowest daily temperature',
  weatherForecast: {
    title: 'forecast',
    columns: {
      period: 'Market period',
      airTemperature: 'Air temperature',
      windSpeed10m: 'Wind speed (10m)',
      windSpeed100m: 'Wind speed (100m)',
      windDirection10m: 'Wind direction(10m)',
      windDirection100m: 'Wind direction(100m)',
      globalHorizontalIrradiance: 'Global horizontal irradiance GHI',
      globalHorizontalIrradiance10: 'GHI10',
      globalHorizontalIrradiance90: 'GHI90',
      diffuseHorizontalIrradiance: 'Diffuse horizontal irradiance DHI',
      diffuseHorizontalIrradiance10: 'DHI10',
      diffuseHorizontalIrradiance90: 'DHI90',
      directNormalIrradiance: 'Direct normal irradiance DNI',
      globalTiltedIrradiance: 'Global tilted irradiance GTI',
      globalTiltedIrradiance10: 'GTI10',
      globalTiltedIrradiance90: 'GTI90',
      cloudOpacity: 'Cloud opacity'
    }
  },
  weatherMeasurementHistory: {
    title: 'measurement history',
    columns: {
      period: 'Period',
      airTemperature: 'Air temperature',
      windSpeed: 'Wind speed',
      windDirection: 'Wind direction',
      globalHorizontalIrradiance: 'Global horizontal irradiance GHI',
      atmosphericPressure: 'Atmospheric pressure',
      relativeHumidity: 'Relative humidity',
      dewPointTemperature: 'Dew point temperature',
      rainfallRate: 'Rainfall rate',
      waterSnowEquivalent: 'Water snow equivalent'
    }
  }
};

export default enDispatcherWeatherWidget;
